import tones3 from "./types/tones3";
import tones5 from "./types/tones5";
import driving from "./types/driving";
import itc from "./types/itc";

export default [tones3, tones5, driving, itc];
